import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { FiUserPlus, FiUserMinus, FiDownload } from "react-icons/fi";
import { Popover } from "@mui/material";
import "../../src/teamManage.css";
import { toast } from "react-toastify";
import { Chess } from "chess.js";
import { Chessboard } from "react-chessboard";
import MatchMoves from './matchMoves.js'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel,
  Tabs,
  Tab,
  Box,
  Tooltip,
  CircularProgress
} from "@mui/material";

import {
  addUserInTeamApi,
  fetchTeamDetailswoyhoutPagination,
  getUserInTeamApi,
  deleteUserInTeamApi,
  fetchUserStats,
  addUserInTeamApiBulk,
  deleteUserInTeamApiBulk,
  fetchUserTournamentApi,
  fetchMoves,
  bulkUploadUsersToTeamApi
} from "../api/teamsApi";
import { getApiErrorMessage } from "../utils/apiError";
import { CostExplorer } from "aws-sdk";
import { red } from "@mui/material/colors";






const TeamManage = () => {
  const navigate = useNavigate();

  // Top-right, auto dismiss, solid green/red background
  const TOAST_OPTIONS = {
    position: "top-right",
    autoClose: 3000,
    theme: "colored",
  };

  // success/failure message straight off a response body
  const getApiMessage = (body, fallback) => body?.msg || body?.message || fallback;

  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Stats sidebar state
  const [statsOpen, setStatsOpen] = useState(false);
  const [selectedUserStats, setSelectedUserStats] = useState(null);

  // pagination — driven by the server, not by slicing the array here
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const usersPerPage = 10; // items per page sent to the API
  const [jumpPage, setJumpPage] = useState("");
  const [pageError, setPageError] = useState("");

  // the users table keeps this height while empty, so the layout does not jump
  const USER_TABLE_COLUMNS = 8;
  const USER_ROW_HEIGHT = 44;
  const EMPTY_USER_TABLE_HEIGHT = usersPerPage * USER_ROW_HEIGHT;

  // bulk upload state
  const bulkFileInputRef = useRef(null);
  const [bulkUploading, setBulkUploading] = useState(false);

  // form states
  const [newName, setNewName] = useState("");
  const [newUserId, setNewUserId] = useState("");
  const [newTeam, setNewTeam] = useState(null);
  const [addUserErrors, setAddUserErrors] = useState({
    name: "",
    userId: "",
    team: ""
  });

  const USER_NAME_MAX_LENGTH = 150;

  // pure — lets the Confirm button ask "is this form valid?" on every render
  const buildAddUserErrors = () => {
    const errors = { name: "", userId: "", team: "" };

    if (!newName.trim()) {
      errors.name = "Name is required.";
    } else if (newName.length > USER_NAME_MAX_LENGTH) {
      errors.name = `Name must be at most ${USER_NAME_MAX_LENGTH} characters.`;
    }

    if (!newUserId.trim()) {
      errors.userId = "User number is required.";
    } else if (!/^\d+$/.test(newUserId.trim())) {
      errors.userId = "User number must contain digits only.";
    }

    if (!newTeam) {
      errors.team = "Please select a group.";
    }

    return errors;
  };

  const isAddUserValid = Object.values(buildAddUserErrors()).every((value) => value === "");

  // sorting states
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  // checkbox
  const [checkboxselectedUsers, setcheckboxSelectedUsers] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterAnchor, setFilterAnchor] = useState(null);
  // const [isApplyDisabled, setIsApplyDisabled] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  // Tournament detail modal
  const [tournamentModalOpen, setTournamentModalOpen] = useState(false);
  const [selectedTournamentUser, setSelectedTournamentUser] = useState(null);
  const [tournamentData, setTournamentData] = useState([]);
  const [tournamentPage, setTournamentPage] = useState(1);
  const [tournamentTotalPages, setTournamentTotalPages] = useState(1);
  const [tournamentLoading, setTournamentLoading] = useState(false);
  const [matchMovesData, setMatchMovesData] = useState(null);

  const [selectedMove, setSelectedMove] = useState(null);
  // Auto play and pause for move animation
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalRef = useRef(null);

  // match stats filters


  const [sourceFilter, setSourceFilter] = useState("");

  const [matchDurationFilter, setMatchDurationFilter] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [color, setColorFilter] = useState("");
  const [result, setResultFilter] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseforMatchStats = () => {
    setAnchorEl(null);
  };

  const openFilterforMatchStats = Boolean(anchorEl);




  const [selectedTab, setSelectedTab] = useState(0);


  const TOURNAMENT_LIMIT = 10;

  const [matchModalOpen, setMatchModalOpen] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState(null);

  const handleUsernameClick = async (user) => {
    console.log(user.userId, "selected user for tournament")
    // setSelectedTournamentUser(user);
    // setTournamentModalOpen(true);
    setSelectedTournamentUser(user);
    setTournamentModalOpen(true);
    setTournamentPage(1);

    await loadTournamentData(user.userId, 1);
  };



  const getGroupedFullGameMoves = () => {
    const userMoves = matchMovesData?.moves || [];
    const opponentMoves = matchMovesData?.opponentMoves || [];

    // Merge both arrays
    const allMoves = [...userMoves, ...opponentMoves];

    // Sort by moveNumber
    allMoves.sort((a, b) => a.moveNumber - b.moveNumber);

    const grouped = [];

    for (let i = 0; i < allMoves.length; i += 2) {
      grouped.push({
        moveNumber: Math.ceil(allMoves[i].moveNumber / 2),
        white: allMoves[i]?.color === "White" ? allMoves[i] : null,
        black: allMoves[i + 1]?.color === "Black" ? allMoves[i + 1] : null,
      });
    }

    return grouped;
  };


  const allMoves = [
    ...(matchMovesData?.moves || []),
    ...(matchMovesData?.opponentMoves || [])
  ].sort((a, b) => a.moveNumber - b.moveNumber);



  const loadTournamentData = async (userId,
    page,
    source = "",
    fromDate = "",
    toDate = "",
    matchDurationFilter = "",
    color = '',
    result = ''
  ) => {
    console.log(userId, page, "loading tournament data for user and page")
    try {
      setTournamentLoading(true);

      const res = await fetchUserTournamentApi({
        userId,
        page,
        limit: TOURNAMENT_LIMIT,
        source,
        fromDate,
        toDate,
        matchDurationFilter,
        color,
        result
      });
      console.log(res, "res")
      setTournamentData(res?.data?.items || []);
      setTournamentTotalPages(res?.data?.totalPages || 1);
      setTournamentPage(page);
    } catch (err) {
      console.error("Failed to load matchMStatsByMoves data", err);
      setTournamentData([]);
    } finally {
      setTournamentLoading(false);
    }
  };

  const handleMatchClick = (row) => {
    setSelectedMatch(row);

    setMatchModalOpen(true);
  };

  const downloadPgn = async (row) => {
    try {
      const res = await fetchMoves(row);
      const movesData = res?.data?.data || res?.data;
      const pgn = movesData?.pgn;

      // The browser gives no callback for whether the user actually saves or
      // cancels the file dialog, so we can only confirm what we control:
      // the PGN was fetched successfully and the download was initiated.
      if (!pgn) {
        toast.error("No PGN data available for this match.", TOAST_OPTIONS);
        return;
      }

      const blob = new Blob([pgn], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${row.matchId || movesData.matchId || "match"}.pgn`; // file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // alert("PGN download started.");
    } catch (error) {
      console.error("Error downloading PGN:", error);
      toast.error(getApiErrorMessage(error, "Failed to download PGN, please try again."), TOAST_OPTIONS);
    }
  }

  const today = new Date().toISOString().split("T")[0];

  // Apply is enabled only for a complete, non-future, correctly-ordered date range
  const isApplyDisabled =
    !startDate ||
    !endDate ||
    startDate > today ||
    endDate > today ||
    startDate > endDate;

  const [dateError, setDateError] = useState({
    start: "",
    end: "",
  });

  // Shared rules: no future dates, and end date must be on/after start date.
  const getDateErrors = (start, end) => {
    const errors = { start: "", end: "" };

    if (start && start > today) {
      errors.start = "Start date cannot be in the future";
    }

    if (end && end > today) {
      errors.end = "End date cannot be in the future";
    } else if (start && end && end < start) {
      errors.end = "End date should be equal or greater than start date";
    }

    return errors;
  };

  const validateDates = () => {
    if (!startDate && !endDate) {
      return false;
    }

    const errors = getDateErrors(startDate, endDate);

    if (!startDate && endDate) {
      errors.start = errors.start || "Start date is required";
    }

    if (startDate && !endDate) {
      errors.end = errors.end || "End date is required";
    }

    setDateError(errors);
    return !errors.start && !errors.end;
  };


  // fetch teams
  const getTeams = async () => {
    try {
      const response = await fetchTeamDetailswoyhoutPagination();
      const teams = response.data.data;

      setTeams(teams);
      if (teams.length > 0) {
        setSelectedTeam(teams[0].id);
        setNewTeam(teams[0].id);
        getUserInTeam(teams[0].id);
      }
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };
  // fetch users
  const getUserInTeam = async (teamId, fromDate, toDate, page = 1) => {
    try {
      setUsersLoading(true);
      const payload = {
        teamId,
        page,
        // pageNo is sent as an alias — this repo has endpoints on both conventions
        pageNo: page,
        limit: usersPerPage
      };

      if (fromDate) payload.startDate = fromDate;
      if (toDate) payload.endDate = toDate;

      const res = await getUserInTeamApi(payload);

      // the endpoint answers { data: { total, data: [...], currentPage, totalPages } };
      // older builds answered with a plain array, so both are accepted
      const payloadData = res?.data;
      const list = Array.isArray(payloadData) ? payloadData : payloadData?.data;

      setUsers(Array.isArray(list) ? list : []);
      setTotalPages(payloadData?.totalPages || 1);
      setTotalUsers(payloadData?.total || (Array.isArray(list) ? list.length : 0));
      setCurrentPage(payloadData?.currentPage || page);
      setcheckboxSelectedUsers([]);
    } catch (err) {
      console.error("Error fetching users:", err);
      setUsers([]);
      setTotalPages(1);
      setTotalUsers(0);
    } finally {
      setUsersLoading(false);
    }
  };

  // every page change goes back to the server
  const handleUsersPageChange = (page) => {
    if (page < 1 || page > totalPages) {
      return;
    }
    setPageError("");
    getUserInTeam(selectedTeam, startDate, endDate, page);
  };

  const handleJumpSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (usersLoading) {
      return;
    }

    const rawVal = jumpPage.trim();
    if (!rawVal) {
      const msg = totalPages <= 1
        ? "Please enter a valid page number."
        : `Please enter a page number between 1 and ${totalPages}.`;
      setPageError(msg);
      toast.error(msg, TOAST_OPTIONS);
      return;
    }

    const pageNum = Number(rawVal);
    if (isNaN(pageNum) || !Number.isInteger(pageNum) || pageNum < 1 || pageNum > totalPages) {
      const msg = totalPages <= 1
        ? "Page number must be 1."
        : `Please enter a page number between 1 and ${totalPages}.`;
      setPageError(msg);
      toast.error(msg, TOAST_OPTIONS);
      return;
    }

    setPageError("");
    handleUsersPageChange(pageNum);
    setJumpPage("");
  };



  const moveTypes = useMemo(() => {
    const types =
      matchMovesData?.moves?.map(m => m.moveType) || [];

    const uniqueTypes = [...new Set(types)];

    return [...uniqueTypes, "Full Game"];
  }, [matchMovesData]);

  var pairedMoves = [];
  // Filter moves based on selected tab
  console.log(moveTypes[selectedTab], "selected tab")
  const filteredMoves =
    moveTypes[selectedTab] === "Full Game"
      ? (() => {
        const userMoves = matchMovesData?.moves || [];
        const opponentMoves = matchMovesData?.opponentMoves || [];

        const merged = [];
        const maxLength = Math.max(userMoves.length, opponentMoves.length);

        for (let i = 0; i < maxLength; i++) {
          if (userMoves[i]) merged.push(userMoves[i]);
          if (opponentMoves[i]) merged.push(opponentMoves[i]);
        }

        return merged;
      })()
      : (() => {
        const userMoves = matchMovesData?.moves || [];
        const opponentMoves = matchMovesData?.opponentMoves || [];

        const filtered = userMoves.filter(
          m => m.moveType === moveTypes[selectedTab]
        );

        const pairedMoves = [];

        filtered.forEach((move) => {
          let whiteMove = null;
          let blackMove = null;

          let opponentMove;

          if (move.color === "White") {
            whiteMove = move;

            opponentMove = opponentMoves.find(
              op => op.moveNumber === move.moveNumber + 1
            );

            if (opponentMove) blackMove = opponentMove;
          } else {
            blackMove = move;

            opponentMove = opponentMoves.find(
              op => op.moveNumber === move.moveNumber - 1
            );

            if (opponentMove) whiteMove = opponentMove;
          }

          pairedMoves.push({
            white: whiteMove,
            black: blackMove
          });
        });
        console.log(pairedMoves, "paired moves for selected tab")
        return pairedMoves;
      })();

  const onChangetabs = (e, newValue) => {
    setSelectedTab(newValue);
    console.log(newValue, "new value")

    const movesOfTab = matchMovesData?.moves?.filter(
      m => m.moveType === moveTypes[newValue]
    ) || [];

    setSelectedMove(movesOfTab[0] || null); // ✅ auto select first
  }
  const userColor = matchMovesData?.moves[0]?.color;
  let currentPairIndex = -1;
  let currentSide = null;

  filteredMoves.forEach((pair, index) => {
    if (
      pair.white?.move === selectedMove?.move &&
      pair.white?.moveNumber === selectedMove?.moveNumber
    ) {
      currentPairIndex = index;
      currentSide = "white";
    }

    if (
      pair.black?.move === selectedMove?.move &&
      pair.black?.moveNumber === selectedMove?.moveNumber
    ) {
      currentPairIndex = index;
      currentSide = "black";
    }
  });

  const handleNext = () => {
    if (currentPairIndex === -1) return;

    const currentPair = filteredMoves[currentPairIndex];

    // USER = WHITE
    if (userColor === "White") {

      // If black active → go to white same pair
      if (currentSide === "black" && currentPair?.white) {
        const nextPair = filteredMoves[currentPairIndex + 1];
        if (nextPair?.white) {
          setSelectedMove(nextPair.white);
        }
      }

      // If white active → go to white of next pair
      if (currentSide === "white") {
        const nextPair = filteredMoves[currentPairIndex + 1];
        if (nextPair?.white) {
          setSelectedMove(nextPair.white);
        }
      }
    }

    // USER = BLACK
    if (userColor === "Black") {

      // If white active → go to black same pair
      if (currentSide === "white" && currentPair?.black) {
        setSelectedMove(currentPair.black);
        return;
      }

      // If black active → go to black of next pair
      if (currentSide === "black") {
        const nextPair = filteredMoves[currentPairIndex + 1];
        if (nextPair?.black) {
          setSelectedMove(nextPair.black);
        }
      }
    }
  };

  const handlePrev = () => {
    if (currentPairIndex === -1) return;

    const currentPair = filteredMoves[currentPairIndex];
    const prevPair = filteredMoves[currentPairIndex - 1];


    // USER = WHITE
    if (userColor === "White") {

      // If black active → go to white same pair
      if (currentSide === "black" && currentPair?.white) {
        setSelectedMove(currentPair.white);
        return;
      }

      // If white active → go to white of previous pair
      if (currentSide === "white") {
        const prevPair = filteredMoves[currentPairIndex - 1];
        if (prevPair?.white) {
          setSelectedMove(prevPair.white);
        }
      }
    }

    // USER = BLACK
    if (userColor === "Black") {

      // If white active → go to black previous pair
      if (currentSide === "white" && prevPair?.black) {
        setSelectedMove(prevPair.black);
        return;
      }

      // If black active → go to black previous pair
      if (currentSide === "black" && prevPair?.black) {
        setSelectedMove(prevPair.black);
        return;
      }
    }
  };

  const fullGameMoves = useMemo(() => {
    const userMoves = matchMovesData?.moves || [];
    const opponentMoves = matchMovesData?.opponentMoves || [];

    return [...userMoves, ...opponentMoves]
      .sort((a, b) => a.moveNumber - b.moveNumber);
  }, [matchMovesData]);

  const currentIndexfullGame = fullGameMoves.findIndex(
    m =>
      m.moveNumber === selectedMove?.moveNumber &&
      m.san === selectedMove?.san
  );

  const handleNextFullGame = () => {
    if (currentIndexfullGame < fullGameMoves.length - 1) {
      setSelectedMove(fullGameMoves[currentIndexfullGame + 1]);
    }
  };

  const handlePrevFullGame = () => {
    if (currentIndexfullGame > 0) {
      setSelectedMove(fullGameMoves[currentIndexfullGame - 1]);
    }
  };



  // useEffect(() => {
  //   if (!sideOpen) {
  //     stopAutoPlay();
  //   }
  // }, [sideOpen]);

  useEffect(() => {
    if (selectedTab !== "Full Game") {
      stopAutoPlay();
    }
  }, [selectedTab]);


  const startAutoPlay = () => {
    // if (selectedTab !== "Full Game") return; // prevent start on other tabs

    if (intervalRef.current) return;

    setIsPlaying(true);

    intervalRef.current = setInterval(() => {
      setSelectedMove((prevMove) => {
        if (!prevMove) return prevMove;

        const currentIndex = fullGameMoves.findIndex(
          (m) =>
            m.moveNumber === prevMove.moveNumber &&
            m.san === prevMove.san
        );

        const nextIndex = currentIndex + 1;

        if (nextIndex >= fullGameMoves.length) {
          stopAutoPlay();
          return prevMove;
        }

        return fullGameMoves[nextIndex];
      });
    }, 3000);
  };

  const stopAutoPlay = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setIsPlaying(false);
  };


  const onBlunderClick = (move) => {
    console.log(move, "move")
    setSelectedMove(move);
    setSideOpen(true);
  };

  const [initialMoveType, setInitialMoveType] = useState(null);

  const handleMovesInAnimation = async (row, moveType) => {
    try {
      console.log(moveType, "row.moveType")
      setInitialMoveType(moveType);

      const res = await fetchMoves(row);

      if (!res || !res.data) {
        console.error("Invalid response:", res);
        return;
      }

      const matchData = res.data?.data || res.data;
      setMatchMovesData(matchData);
      setSideOpen(true);

    } catch (error) {
      // error.response is absent on network failures, so read it defensively
      toast.error(getApiErrorMessage(error, "Failed to load moves, please try again."), TOAST_OPTIONS);
      console.error("Error fetching moves:", error);
    }
  };






  useEffect(() => {
    const init = async () => {
      try {
        const data = await fetchTeamDetailswoyhoutPagination();
        const teamsList = data.data.data;

        setTeams(teamsList);

        if (teamsList.length > 0) {
          setSelectedTeam(teamsList[0].id);
          setNewTeam(teamsList[0].id);
          getUserInTeam(teamsList[0].id);
        } else {
          setUsersLoading(false);
        }
      } catch (error) {
        console.error("Error initializing teams:", error);
        setUsersLoading(false);
      }
    };

    init();
  }, []);




  // delete user 

  const handleDeleteUser = async (teamId, userId) => {
    try {
      const payload = {
        teamId,
        deleteUserId: userId,
      };
      const res = await deleteUserInTeamApi(payload);

      // the backend spells it "sucess" on this endpoint
      if (res?.sucess || res?.success) {
        toast.success(getApiMessage(res, "User deleted successfully"), TOAST_OPTIONS);
        setCurrentPage(1);
        setUsers((prev) => prev.filter((u) => !(u.teamId === teamId && u.userId === userId)));
        getUserInTeam(selectedTeam, startDate, endDate);
      } else {
        toast.error(getApiMessage(res, "Failed to delete user"), TOAST_OPTIONS);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error(getApiErrorMessage(error, "Failed to delete user. Please try again."), TOAST_OPTIONS);
    }
  };

  // filter users for selected team
  // const filteredUsers = Array.isArray(users)
  //   ? users
  //     .filter((u) => u.teamId === selectedTeam)
  //     .filter((u) =>
  //       u.username.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  //   : [];

  const filteredUsers = users.filter((u) => {
    const searchLower = searchQuery.toLowerCase().trim();
    const username = u.username?.toLowerCase() || "";
    const mobile = u.userDetails?.mobile?.toString() || "";

    return (
      username.includes(searchLower) ||
      mobile.includes(searchLower)
    );
  });

  const isAllSelectedcheckbox = filteredUsers.length > 0 && checkboxselectedUsers.length === filteredUsers.length;


  // back to dashboard
  const handleBackClick = () => {
    navigate("/dashboard");
  };

  // bulk upload user handles
  const handleUploadBulkUserClick = () => {
    if (bulkFileInputRef.current) {
      bulkFileInputRef.current.value = "";
      bulkFileInputRef.current.click();
    }
  };

  const handleBulkFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileName = file.name || "";
    if (!fileName.toLowerCase().endsWith(".csv")) {
      toast.error("Only CSV files are allowed (.csv)", TOAST_OPTIONS);
      if (bulkFileInputRef.current) {
        bulkFileInputRef.current.value = "";
      }
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("teamId", "6");

    try {
      setBulkUploading(true);
      const res = await bulkUploadUsersToTeamApi(formData);

      if (res?.success === false || res?.sucess === false) {
        toast.error(getApiMessage(res, "Failed to upload bulk users."), TOAST_OPTIONS);
        return;
      }

      toast.success(getApiMessage(res, "Bulk users uploaded successfully!"), TOAST_OPTIONS);
      getUserInTeam(selectedTeam, startDate, endDate, currentPage);
    } catch (error) {
      console.error("Bulk upload users failed:", error);
      toast.error(getApiErrorMessage(error, "Failed to upload bulk users."), TOAST_OPTIONS);
    } finally {
      setBulkUploading(false);
      if (bulkFileInputRef.current) {
        bulkFileInputRef.current.value = "";
      }
    }
  };

  // dialog open/close
  const handleAddNewUserClick = () => {
    setAddUserErrors({ name: "", userId: "", team: "" });
    setOpen(true)
  };
  const handleClose = () => {
    setOpen(false);
    setNewName("");
    setNewUserId("");
    setNewTeam(selectedTeam);
    setAddUserErrors({ name: "", userId: "", team: "" });
  };

  // confirm add user
  const handleConfirm = async () => {
    try {
      const errors = buildAddUserErrors();
      setAddUserErrors(errors);
      if (Object.values(errors).some((value) => value !== "")) {
        return;
      }

      const payload = {
        username: newName.trim(),
        addUserId: newUserId.trim(),
        teamID: newTeam,
      };

      const response = await addUserInTeamApi(payload);

      if (response?.success === false || response?.sucess === false) {
        toast.error(getApiMessage(response, "Failed to add user, please try again."), TOAST_OPTIONS);
        return;
      }

      if (response) {
        toast.success(getApiMessage(response, "User added successfully"), TOAST_OPTIONS);
        getUserInTeam(selectedTeam, startDate, endDate);
        setUsers((prev) => [
          ...prev,
          {
            id: Date.now(), // temporary ID until backend returns real one
            username: newName,
            mobile: newUserId,
            teamId: newTeam,
          },
        ]);
      }
      handleClose();
    } catch (err) {
      console.error("Add user failed:", err);
      toast.error(getApiErrorMessage(err, "Failed to add user, please try again."), TOAST_OPTIONS);
    }
  };


  // Open stats drawer
  const handleOpenStats = async (user) => {
    let data = await fetchUserStats(user.userId);
    let setData = {
      username: user.username,
      play: data.stats.matches_played,
      won: data.stats.matches_won,
      point: data.stats.points
    }

    setSelectedUserStats(setData);
    setStatsOpen(true);
  };

  const handleCloseStats = () => {
    setStatsOpen(false);
    setSelectedUserStats(null);
  }


  // show select team
  const [showTeamSelect, setShowTeamSelect] = useState(false);
  const [selectedTeamId, setSelectedTeamId] = useState("");

  // chess moves
  const [sideOpen, setSideOpen] = useState(false);


  useEffect(() => {
    if (sideOpen && moveTypes.length > 0 && matchMovesData) {

      let tabIndex = 0;

      if (initialMoveType) {
        const foundIndex = moveTypes.findIndex(
          type => type === initialMoveType
        );

        if (foundIndex !== -1) {
          tabIndex = foundIndex;
        }
      }

      setSelectedTab(tabIndex);

      const selectedType = moveTypes[tabIndex];

      const movesOfTab =
        matchMovesData?.moves?.filter(
          m => m.moveType === selectedType
        ) || [];

      setSelectedMove(movesOfTab[0] || null);
    }
  }, [sideOpen, moveTypes, matchMovesData, initialMoveType]);


  useEffect(() => {
    if (moveTypes[selectedTab] === "Full Game") {
      const grouped = getGroupedFullGameMoves();

      if (grouped.length > 0) {
        // Select white first move by default
        setSelectedMove(grouped[0].white || grouped[0].black);
      }
    }
  }, [selectedTab, matchMovesData]);




  // checkbox handles
  const handleSelectAll = () => {
    if (isAllSelectedcheckbox) {
      setcheckboxSelectedUsers([]);
    } else {
      setcheckboxSelectedUsers(filteredUsers.map((u) => u));
    }

  };

  // sorting function
  const handleSortColumn = (column) => {
    if (sortColumn === column) {
      // Toggle direction if same column clicked
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Set new column with ascending order
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  // sort filtered users
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (!sortColumn) return 0;

    let aValue, bValue;

    switch (sortColumn) {
      case "username":
        aValue = a.username?.toLowerCase() || "";
        bValue = b.username?.toLowerCase() || "";
        break;
      case "mobile":
        aValue = a.userDetails?.mobile || "";
        bValue = b.userDetails?.mobile || "";
        break;
      case "gamesPlayed":
        aValue = a.matchesPlayed ?? 0;
        bValue = b.matchesPlayed ?? 0;
        break;
      case "gamesWon":
        aValue = a.matchesWon ?? 0;
        bValue = b.matchesWon ?? 0;
        break;
      case "tournamentsPlayed":
        aValue = a.tournamentsPlayed || 0;
        bValue = b.tournamentsPlayed || 0;
        break;
      case "tournamentsWon":
        aValue = a.tournamentsWon || 0;
        bValue = b.tournamentsWon || 0;
        break;
      default:
        return 0;
    }

    if (typeof aValue === "string") {
      return sortDirection === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    } else {
      return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
    }
  });

  // the server already returned exactly this page — search and sort apply to it
  const currentUsers = sortedUsers;


  const handleSelectUser = (userId) => {
    setcheckboxSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleAddUserInTeamBulk = async () => {
    console.log(checkboxselectedUsers, "add user team bulk")
    const transformed = checkboxselectedUsers.map(user => ({
      username: user.username,
      addUserId: user.userDetails?.mobile
    }));
    if (transformed.length === 0 || !selectedTeamId) {
      toast.error("Please select at least one user and a team", TOAST_OPTIONS);
      return;
    }
    const payload = {
      users: transformed,
      teamID: selectedTeamId,
    };


    console.log(payload, "payload")

    try {
      const response = await addUserInTeamApiBulk(payload);

      if (response?.success === false || response?.sucess === false) {
        toast.error(getApiMessage(response, "Failed to add users to the group."), TOAST_OPTIONS);
        return;
      }

      toast.success(getApiMessage(response, "Users added to the group successfully"), TOAST_OPTIONS);
      getUserInTeam(selectedTeam, startDate, endDate);
    } catch (error) {
      console.error("Bulk add users failed:", error);
      toast.error(getApiErrorMessage(error, "Failed to add users to the group."), TOAST_OPTIONS);
    }

  }

  const handleDeleteUserInTeamBulk = async () => {
    console.log(checkboxselectedUsers, "delete user team bulk")
    const userIds = checkboxselectedUsers.map(user => user.userId);
    let teamId = teams.find((t) => t.id === selectedTeam)?.id

    if (userIds.length === 0) {
      toast.error("Please select at least one user to delete", TOAST_OPTIONS);
      return;
    }

    const payload = {
      teamId,
      deleteUserId: userIds
    };


    try {
      const res = await deleteUserInTeamApiBulk(payload);

      // the backend spells it "sucess" on this endpoint
      if (res?.sucess === true || res?.success === true) {
        toast.success(getApiMessage(res, "Users removed from the group successfully"), TOAST_OPTIONS);
        getUserInTeam(selectedTeam, startDate, endDate);
      } else {
        toast.error(getApiMessage(res, "Failed to remove users from the group."), TOAST_OPTIONS);
      }
    } catch (error) {
      console.error("Bulk delete users failed:", error);
      toast.error(getApiErrorMessage(error, "Failed to remove users from the group."), TOAST_OPTIONS);
    }

  }

  const handleAddUserInParticulerUser = (user) => {
    console.log(user, "user")
    setOpen(true)
    setNewName(user.username);
    setNewUserId(user?.userDetails?.mobile);
    setNewTeam(selectedTeam);
  }
  const getPaginationRange = (currentPage, totalPages) => {
    currentPage = Number(currentPage);
    totalPages = Number(totalPages);

    const delta = 2;
    const pages = [];

    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };








  // keeps the Groups panel exactly as tall as the users area above the pagination
  const usersPanelRef = useRef(null);
  const [groupsPanelHeight, setGroupsPanelHeight] = useState(null);

  useEffect(() => {
    const node = usersPanelRef.current;
    if (!node) {
      return;
    }

    const syncHeight = () => setGroupsPanelHeight(node.offsetHeight);

    syncHeight();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", syncHeight);
      return () => window.removeEventListener("resize", syncHeight);
    }

    const observer = new ResizeObserver(syncHeight);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const listContainerRef = useRef(null);
  const moveRefs = useRef({});

  useEffect(() => {
    if (!selectedMove) return;
    console.log(selectedMove, "selectedMove")

    const key = `${selectedMove.moveNumber}-${selectedMove.move}`;
    const element = moveRefs.current[key];

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [selectedMove]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear())

    return `${day}-${month}-${year}`;
  };

  const GROUP_NAME_DISPLAY_LIMIT = 25;

  const truncateGroupName = (name) => {
    if (!name) {
      return "";
    }
    return name.length > GROUP_NAME_DISPLAY_LIMIT
      ? `${name.slice(0, GROUP_NAME_DISPLAY_LIMIT)}...`
      : name;
  };




  return (
    <div className="team-container">
      <h1>Users</h1>

      {/* Header */}
      <div className="header">
        <Button
          variant="contained"
          color="secondary"
          onClick={handleBackClick}
          sx={{ marginBottom: 2 }}
        >
          Back to Dashboard
        </Button>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <input
            type="file"
            ref={bulkFileInputRef}
            accept=".csv"
            style={{ display: "none" }}
            onChange={handleBulkFileChange}
          />
          <button
            className="btn-add"
            onClick={handleUploadBulkUserClick}
            disabled={bulkUploading}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              cursor: bulkUploading ? "not-allowed" : "pointer",
              opacity: bulkUploading ? 0.7 : 1,
            }}
          >
            {bulkUploading && <CircularProgress size={14} color="inherit" />}
            Upload Bulk User
          </button>
          <button className="btn-add" onClick={handleAddNewUserClick}>
            + Add New User
          </button>
          <Button
            variant="outlined"
            onClick={(e) => setFilterAnchor(e.currentTarget)}
          >
            Filter
          </Button>
          <Popover
            open={Boolean(filterAnchor)}
            anchorEl={filterAnchor}
            onClose={() => setFilterAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <div style={{ padding: "16px", width: "260px" }}>
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                error={!!dateError.start}
                helperText={dateError.start}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: today }}
                value={startDate || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setStartDate(value);
                  setDateError(getDateErrors(value, endDate));
                  // setIsApplyDisabled(false)
                }}
                sx={{ mb: 2 }}
              />

              <TextField
                label="End Date"
                type="date"
                fullWidth
                error={!!dateError.end}
                helperText={dateError.end}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: today }}
                value={endDate || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setEndDate(value);
                  setDateError(getDateErrors(startDate, value));
                  // setIsApplyDisabled(false)
                }}
                sx={{ mb: 2 }}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  color="secondary"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setDateError({ start: "", end: "" });
                    setFilterAnchor(null);
                    setIsFilterApplied(false);
                    // setIsApplyDisabled(false);
                    getUserInTeam(selectedTeam);
                  }}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  disabled={isApplyDisabled}
                  onClick={() => {
                    if (!validateDates()) return;
                    setFilterAnchor(null);
                    setIsFilterApplied(true);
                    setCurrentPage(1);
                    getUserInTeam(selectedTeam, startDate, endDate);
                    // setIsApplyDisabled(true);
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          </Popover>
        </div>
      </div>
      <div className="content">
        {/* Left - Teams */}
        <div
          className="teams-section"
          style={groupsPanelHeight ? { height: `${groupsPanelHeight}px` } : undefined}
        >
          <h3>Groups</h3>
          <ul className="team-list">
            {teams.map((team) => (
              <Tooltip title={team.name || ""} key={team.id}>
                <li
                  className={`team-item ${selectedTeam === team.id ? "active" : ""
                    }`}
                  onClick={() => {
                    setSelectedTeam(team.id);
                    setCurrentPage(1);
                    // the previous destination may now be the group being viewed
                    setSelectedTeamId("");
                    getUserInTeam(team.id, startDate, endDate, 1);
                  }}
                >
                  {team.name}
                </li>
              </Tooltip>
            ))}
          </ul>
        </div>

        {/* Right - Users */}
        <div className="users-section">
          {/* measured so the Groups panel can match this height (pagination excluded) */}
          <div ref={usersPanelRef}>
            <h3>
              {teams.find((t) => t.id === selectedTeam)?.name || "Select a Team"} - Users
            </h3>
            <div className="userActionButton">
              <button className="btn-add" onClick={handleSelectAll}>
                Select All
              </button>

              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <button
                  className="btn-add"
                  onClick={() => setShowTeamSelect((prev) => !prev)}
                >
                  Add to Group
                </button>

                {showTeamSelect && (
                  <select style={{ height: "34px", width: "180px", marginRight: "10px", borderRadius: "5px" }}
                    value={selectedTeamId}
                    onChange={(e) => setSelectedTeamId(e.target.value)}
                    title={teams.find((t) => t.id === selectedTeamId)?.name || ""}
                  >
                    <option value="">Select a Team</option>
                    {/* the group being viewed is not a valid destination */}
                    {teams
                      .filter((team) => team.id !== selectedTeam)
                      .map((team) => (
                        <option key={team.id} value={team.id} title={team.name}>
                          {truncateGroupName(team.name)}
                        </option>
                      ))}
                  </select>
                )}

                {showTeamSelect && selectedTeamId && (
                  <button
                    className="btn-confirm"
                    onClick={() => handleAddUserInTeamBulk(selectedTeamId)}
                  >
                    Confirm
                  </button>
                )}
              </div>
              {/* <button className="btn-add" onClick={handleAddUserInTeamBulk}>
            Add to Team
          </button> */}

              {teams.find((t) => t.id === selectedTeam)?.isGlobal !== true && (
                <button className="btn-add" onClick={handleDeleteUserInTeamBulk}>
                  Delete from Group
                </button>
              )}

            </div>
            <input
              type="text"
              className="search-bar"
              placeholder="Search by name or mobile number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* <ul className="user-list">
            {filteredUsers.map((user) => (
              <li key={user.id} className="user-item">
                <span>
                  {user.username} ({user.userId})
                </span>
                <span>
                  <button onClick={() => handleOpenStats(user)}>Stats</button>
                  <button className="btn-add" onClick={() => handleOpenStats(user)}>Add to team</button>

                  <FiTrash2
                    className="delete-icon"
                    onClick={() => handleDeleteUser(teams.find((t) => t.id === selectedTeam)?.id, user.userId)}
                  />
                </span>

              </li>
            ))}
            {filteredUsers.length === 0 && (
              <li className="no-result">No users found</li>
            )}
          </ul> */}

            <table className="user-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={isAllSelectedcheckbox}
                    />
                  </th>
                  <th onClick={() => handleSortColumn("username")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Users {sortColumn === "username" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  <th onClick={() => handleSortColumn("mobile")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Mobile {sortColumn === "mobile" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  <th onClick={() => handleSortColumn("gamesPlayed")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Games Played {sortColumn === "gamesPlayed" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  <th onClick={() => handleSortColumn("gamesWon")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Games Won {sortColumn === "gamesWon" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  {/* <th>Game Points</th> */}
                  <th onClick={() => handleSortColumn("tournamentsPlayed")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Tournament Played {sortColumn === "tournamentsPlayed" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  <th onClick={() => handleSortColumn("tournamentsWon")} style={{ cursor: "pointer", userSelect: "none" }}>
                    Tournament Won {sortColumn === "tournamentsWon" && (sortDirection === "asc" ? "↑" : "↓")}
                  </th>
                  {/* <th>Tournament Points</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {usersLoading ? (
                  <tr>
                    <td
                      colSpan={USER_TABLE_COLUMNS}
                      style={{
                        height: EMPTY_USER_TABLE_HEIGHT,
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <CircularProgress size={28} />
                    </td>
                  </tr>
                ) : currentUsers.length > 0 ? (
                  currentUsers.map((user) => (
                    <tr key={user.userId ?? user.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={checkboxselectedUsers.includes(user)}
                          onChange={() => handleSelectUser(user)}
                        />
                      </td>
                      {/* <td>{user?.username}</td> */}
                      <td
                        onClick={() => handleUsernameClick(user)}
                        style={{
                          color: "#1976d2",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                      >
                        {user?.username}
                      </td>

                      <td>{user?.userDetails?.mobile}</td>
                      <td>{user?.matchesPlayed ?? 0}</td>
                      <td>{user?.matchesWon ?? 0}</td>
                      {/* <td>{user?.profileStats?.points || 0}</td> */}
                      <td>{user?.tournamentsPlayed || 0}</td>
                      <td>{user?.tournamentsWon || 0}</td>
                      {/* <td>{user?.tournamentPoints || 0}</td> */}
                      <td>
                        <button
                          onClick={() =>
                            handleAddUserInParticulerUser(
                              user
                            )
                          }
                          style={{
                            background: 'green',
                            color: 'white',
                            border: 'none',
                            padding: '6px 10px',
                            borderRadius: '5px',
                            cursor: 'pointer'
                          }}
                        >
                          <FiUserPlus />
                        </button>
                        {teams.find((t) => t.id === selectedTeam)?.isGlobal !== true && (
                          <button
                            onClick={() =>
                              handleDeleteUser(
                                teams.find((t) => t.id === selectedTeam)?.id,
                                user.userId
                              )
                            }
                            style={{
                              background: 'red',
                              color: 'white',
                              border: 'none',
                              padding: '6px 10px',
                              borderRadius: '5px',
                              cursor: 'pointer'
                            }}
                          >
                            <FaTrash />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={USER_TABLE_COLUMNS}
                      className="no-result"
                      style={{
                        height: EMPTY_USER_TABLE_HEIGHT,
                        textAlign: "center",
                        verticalAlign: "middle",
                        fontWeight: 500,
                        color: "#666",
                      }}
                    >
                      {isFilterApplied ? "No data available for selected dates" : "No Data Available"}
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>

          {/* same Previous / Page X of Y / Next control as Manage Groups —
              hidden while loading and in the no-data scenario */}
          {!usersLoading && users.length > 0 && (
            <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <button
                onClick={() => handleUsersPageChange(currentPage - 1)}
                disabled={usersLoading || currentPage === 1}
              >
                Previous
              </button>
              <span style={{ margin: '0 10px' }}> Page {currentPage} of {totalPages} </span>
              <button
                onClick={() => handleUsersPageChange(currentPage + 1)}
                disabled={usersLoading || currentPage === totalPages}
              >
                Next
              </button>

              <form
                onSubmit={handleJumpSubmit}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginLeft: '15px' }}
              >
                <label htmlFor="team-manage-jump-page" style={{ fontSize: '14px', color: '#444' }}>
                  Jump to page:
                </label>
                <input
                  id="team-manage-jump-page"
                  type="number"
                  min="1"
                  max={totalPages}
                  value={jumpPage}
                  onChange={(e) => {
                    setJumpPage(e.target.value);
                    if (pageError) setPageError('');
                  }}
                  placeholder="Page #"
                  disabled={usersLoading}
                  style={{
                    width: '70px',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    border: pageError ? '1px solid #d32f2f' : '1px solid #ccc',
                    fontSize: '14px',
                    outline: 'none',
                  }}
                />
                <button
                  type="submit"
                  disabled={usersLoading}
                  style={{
                    padding: '4px 12px',
                    cursor: usersLoading ? 'not-allowed' : 'pointer',
                  }}
                >
                  Go
                </button>
              </form>

              {pageError && (
                <span style={{ color: '#d32f2f', fontSize: '13px', marginLeft: '5px' }}>
                  {pageError}
                </span>
              )}
            </div>
          )}



        </div>
      </div>

      {/* Add User Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: "bold" }}>Add User To Group</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            required
            fullWidth
            value={newName}
            onChange={(e) => {
              const value = e.target.value.slice(0, USER_NAME_MAX_LENGTH);
              setNewName(value);
              setAddUserErrors((prev) => ({ ...prev, name: "" }));
            }}
            inputProps={{ maxLength: USER_NAME_MAX_LENGTH }}
            error={Boolean(addUserErrors.name)}
            helperText={addUserErrors.name || `${newName.length}/${USER_NAME_MAX_LENGTH} characters`}
            sx={{ mt: 2 }}
          />
          <TextField
            label="User Number"
            required
            fullWidth
            value={newUserId}
            onChange={(e) => {
              // digits only — letters and special characters are dropped as typed
              const value = e.target.value.replace(/\D/g, "");
              setNewUserId(value);
              setAddUserErrors((prev) => ({ ...prev, userId: "" }));
            }}
            inputProps={{ inputMode: "numeric" }}
            error={Boolean(addUserErrors.userId)}
            helperText={addUserErrors.userId}
            sx={{ mt: 2 }}
          />

          <FormControl fullWidth sx={{ mt: 2 }} required error={Boolean(addUserErrors.team)}>
            <InputLabel id="team-select-label">Select Group</InputLabel>
            <Select
              labelId="team-select-label"
              id="team-select"
              // label must match the InputLabel text so the outline notch lines up
              label="Select Group"
              value={newTeam || ""}
              onChange={(e) => {
                setNewTeam(e.target.value);
                setAddUserErrors((prev) => ({ ...prev, team: "" }));
              }}
              SelectDisplayProps={{ title: teams.find((t) => t.id === newTeam)?.name || "" }}
            >
              {teams.map((team) => (
                <MenuItem key={team.id} value={team.id}>
                  <Tooltip title={team.name || ""}>
                    <span>{truncateGroupName(team.name)}</span>
                  </Tooltip>
                </MenuItem>
              ))}
            </Select>
            {addUserErrors.team && <FormHelperText>{addUserErrors.team}</FormHelperText>}
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            disabled={!isAddUserValid}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>


      {/* Right Sidebar (Stats Drawer) */}
      {/* <Drawer anchor="right" open={statsOpen} onClose={() => setStatsOpen(false)}>
        <div style={{ width: "350px", padding: "20px" }}>
          <span class="close-btn" onClick={() => handleCloseStats()} >&times;</span>

          <h2>Tournament Stats</h2>
          {selectedUserStats && (
            <>
              <p>
                <strong>Name:</strong> {selectedUserStats.username}
              </p>
              <p>
              </p>
            </>
          )}

          <div class="stats-filters">
            <select>
              <option>Global V</option>
              <option>Team V</option>
              <option>Local V</option>
            </select>

            <select>
              <option>Round V</option>
              <option>2 Rounds</option>
              <option>3 Rounds</option>
              <option>5 Rounds</option>
              <option>10 Rounds</option>
            </select>

            <select>
              <option>Min V</option>
              <option>2 mins</option>
              <option>5 mins</option>
              <option>10 mins</option>
            </select>
          </div>

          <div className="stats-table">
            <div className="stats-header">
              <span>Point</span>
              <span>Name</span>
              <span>Play</span>
              <span>Won</span>
            </div>
            <div className="stats-row">
              <span>{selectedUserStats?.point}</span>
              <span>{selectedUserStats?.username}</span>
              <span>{selectedUserStats?.play}</span>
              <span>{selectedUserStats?.won}</span>
            </div>
          </div>
        </div>
      </Drawer> */}

      <Dialog
        open={tournamentModalOpen}

        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setTournamentModalOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {selectedTournamentUser?.username}  Tournament Details
        </DialogTitle>

        {/* Filters Section */}
        <Button
          sx={{ position: "absolute", top: 16, right: 16 }}
          variant="outlined"
          onClick={handleFilterClick}
        >
          Filter
        </Button>

        <Popover
          open={openFilterforMatchStats}
          anchorEl={anchorEl}
          onClose={handleCloseforMatchStats}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Box
            sx={{
              p: 3,
              width: 320,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Source */}
            <FormControl fullWidth size="small">
              <InputLabel>Source</InputLabel>
              <Select
                value={sourceFilter}
                label="Source"
                onChange={(e) => setSourceFilter(e.target.value)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="chesswyze">Chesswyze</MenuItem>
                <MenuItem value="chess.com">Chess.com</MenuItem>
                <MenuItem value="lichess">Lichess</MenuItem>
                <MenuItem value="manul pgn">Manul pgn</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              size="small"
              label="Time Control"
              type="number"
              value={matchDurationFilter}
              onChange={(e) => setMatchDurationFilter(e.target.value)}
              inputProps={{ min: 0 }}
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault();
                }
              }}
            />

            {/* Start Date */}
            <TextField
              label="Start Date"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
              inputProps={{
                max: toDate || today,
              }}
            />

            <TextField
              label="End Date"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
              inputProps={{
                min: fromDate || undefined,
                max: today,
              }}
            />
            <FormControl fullWidth size="small">
              <InputLabel>Color</InputLabel>
              <Select
                value={color}
                label="Color"
                onChange={(e) => setColorFilter(e.target.value)}
              >
                <MenuItem value="White">White</MenuItem>
                <MenuItem value="Black">Black</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth size="small">
              <InputLabel>Result</InputLabel>
              <Select
                value={result}
                label="result"
                onChange={(e) => setResultFilter(e.target.value)}
              >
                <MenuItem value="Win">Win</MenuItem>
                <MenuItem value="Loss">Loss</MenuItem>

              </Select>
            </FormControl>
            {/* Buttons */}
            <Box display="flex" justifyContent="space-between">
              <Button
                color="secondary"
                onClick={() => {
                  setSourceFilter("");
                  setFromDate("");
                  setToDate("");
                  setMatchDurationFilter("");
                  setResultFilter("");
                  setColorFilter("");
                  loadTournamentData(selectedTournamentUser.userId, 1);
                  handleCloseforMatchStats();
                }}
              >
                RESET
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  loadTournamentData(
                    selectedTournamentUser.userId,
                    1,
                    sourceFilter,
                    fromDate,
                    toDate,
                    matchDurationFilter,
                    color,
                    result,
                  );
                  handleCloseforMatchStats();
                  // setSourceFilter("");
                  // setFromDate("");
                  // setToDate("");
                  // setMatchDurationFilter("");
                }}
              >
                APPLY
              </Button>
            </Box>
          </Box>
        </Popover>




        <DialogContent>
          <div style={{ overflowX: "auto", maxHeight: "60vh" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "12px",
              }}
              className="tournament-table"
            >
              <thead>
                <tr>
                  {/* <th rowSpan={2}>Tournament ID</th> */}
                  <th rowSpan={2}>Match ID</th>
                  <th rowSpan={2}>Source</th>
                  {/* <th rowSpan={2}>Format</th> */}
                  <th rowSpan={2}>Time Control</th>
                  {/* <th rowSpan={2}>Round No.</th> */}
                  <th rowSpan={2}>Date</th>
                  <th rowSpan={2}>Time</th>
                  <th rowSpan={2}>Color</th>
                  <th rowSpan={2}>Opp ID</th>
                  {/* <th rowSpan={2}>Opp Pts</th> */}
                  {/* <th rowSpan={2}>User Start Pts</th> */}
                  <th colSpan={8}>Moves</th>
                  <th colSpan={3}>Accuracy</th>
                  <th rowSpan={2}>Result</th>
                </tr>

                <tr>
                  {/* Moves */}
                  <th>Total</th>
                  <th>Book</th>
                  <th>Castling</th>
                  <th>Best</th>
                  {/* <th>Avg Best</th> */}
                  <th>Blunders</th>
                  {/* <th>Avg Blunder</th> */}
                  <th>Misses</th>
                  {/* <th>Avg Missess</th> */}
                  <th>Excellent</th>
                  {/* <th>Avg Excellent</th> */}
                  <th>Brilliant</th>
                  {/* <th>Avg Brilliant</th> */}

                  {/* Accuracy */}
                  <th>Opening</th>
                  <th>Mid</th>
                  <th>End</th>
                </tr>
              </thead>

              <tbody>

                {tournamentLoading ? (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  </tr>
                ) : tournamentData.length > 0 ? (
                  tournamentData.map((row, index) => (
                    <tr key={index}>
                      {/* <td>{row.tournamentId ? row.tournamentId : "NA"}</td> */}
                      <td
                        style={{
                          color: "#1976d2",
                          fontWeight: 500,
                          display: "flex",
                          height: "35px",
                          justifyContent: "center",
                          gap: "8px"
                        }}
                      >
                        <span
                          onClick={() => handleMatchClick(row)}
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {row.matchId}
                        </span>

                        {/* Download icon (UI only, no logic yet) */}
                        <FiDownload
                          onClick={() => downloadPgn(row)}
                          style={{
                            cursor: "pointer",
                            color: "#555",
                            fontSize: "16px",
                          }}
                          title="Download match data"
                        />
                      </td>
                      {/* <td>{row.format}</td>
                    <td>{row.timeFormat}</td>
                    <td>{row.roundNo}</td>
                    <td>{row.date}</td>
                    <td>{row.time}</td>
                    <td>{row.color}</td> */}
                      {/* <td>{row.opponentId}</td>
                    <td>{row.opponentPoints}</td>
                    <td>{row.userStartPoints}</td> */}
                      <td>
                        {row.source
                          ? row.source.charAt(0).toUpperCase() + row.source.slice(1)
                          : ""}
                      </td>
                      {/* <td>
                        {row.tournamentFormat
                          ? row.tournamentFormat.charAt(0).toUpperCase() + row.tournamentFormat.slice(1)
                          : "NA"}
                      </td> */}
                      <td>{row.matchDuration}</td>
                      {/* <td>{row.roundNo ? row.roundNo :"NA"}</td> */}
                      <td style={{ width: "180px", whiteSpace: "nowrap" }}>
                        {formatDate(row.date)}
                      </td>
                      <td>{row.time}</td>
                      <td>{row.color}</td>
                      <td>{row.opponentId}</td>
                      {/* <td>{row.opponentPoints}</td>
                      <td>{row.userStartPoints}</td> */}
                      {/* Moves */}
                      <td style={{
                        color: "#00c853",
                        cursor: "pointer",
                        fontWeight: 600,
                        cursor: row?.noOfMoves === 0 ? "not-allowed" : "pointer",
                      }}
                        onClick={() => {
                          if (row?.noOfMoves !== 0) {
                            handleMovesInAnimation(row, "Full Game");
                          }
                        }}>{row?.noOfMoves ?? "NA"}</td>
                      <td>{row?.bookMoves ?? "NA"}</td>
                      <td>{row?.castlingMoveNo > 0 ? 1 : 0}</td>
                      <td style={{
                        color: "#00c853",
                        cursor: "pointer",
                        fontWeight: 600,
                        cursor: row?.bestMoves === 0 ? "not-allowed" : "pointer",
                      }}
                        onClick={() => {
                          if (row?.bestMoves !== 0) {
                            handleMovesInAnimation(row, "Best Move")
                          }
                        }}
                      >{row?.bestMoves ?? "NA"}</td>
                      {/* <td>{row?.bestMovesAccuracy ?? "NA"}</td> */}
                      <td
                        style={{
                          color: "#d32f2f",
                          cursor: "pointer",
                          fontWeight: 600,
                          cursor: row?.blunders === 0 ? "not-allowed" : "pointer",
                        }}
                        onClick={() => {
                          if (row?.blunders !== 0) {
                            handleMovesInAnimation(row, "Blunder")
                          }
                        }}
                      >
                        {row?.blunders ?? "NA"}
                      </td>
                      {/* <td>{row?.blundersAccuracy ?? "NA"}</td> */}
                      <td style={{
                        color: "#00c853",
                        cursor: "pointer",
                        fontWeight: 600,
                        cursor: row?.misses === 0 ? "not-allowed" : "pointer",

                      }}
                        onClick={() => {
                          if (row?.misses !== 0) {
                            handleMovesInAnimation(row, "Mistake")
                          }
                        }}
                      >{row?.misses ?? "NA"}</td>
                      {/* <td>{row?.missesAccuracy ?? "NA"}</td> */}
                      <td
                        style={{
                          color: "#00c853",
                          cursor: "pointer",
                          fontWeight: 600,
                          cursor: row?.excellentMoves === 0 ? "not-allowed" : "pointer",
                        }}
                        onClick={() => {
                          if (row?.excellentMoves !== 0) {
                            handleMovesInAnimation(row, "Excellent Move")
                          }
                        }}>{row?.excellentMoves ?? "NA"}</td>
                      {/* <td>{row?.excellentMovesAccuracy ?? "NA"}</td> */}
                      <td style={{
                        color: "#00c853",
                        cursor: "pointer",
                        fontWeight: 600,
                        cursor: row?.brilliantMoves === 0 ? "not-allowed" : "pointer",
                      }}
                        onClick={() => {
                          if (row?.brilliantMoves !== 0) {
                            handleMovesInAnimation(row, "Brilliant Move")
                          }
                        }}
                      >{row?.brilliantMoves ?? "NA"}</td>
                      {/* <td>{row?.brilliantMovesAccuracy ?? "NA"}</td> */}
                      {/* Accuracy */}
                      <td>{row?.openingAccuracy ?? "NA"}</td>
                      <td>{row?.midGameAccuracy ?? "NA"}</td>
                      <td>{row?.endGameAccuracy ?? "NA"}</td>
                      <td
                        style={{
                          color: row.result?.toLowerCase() === 'win' ? "green" : "red",
                          fontWeight: 600,
                        }}
                      >

                        {row.result
                          ? row.result.charAt(0).toUpperCase() + row.result.slice(1)
                          : ""}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colspan="100%" style={{ textAlign: "center", width: "100%" }}>
                      No tournament data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>


          {/* pagination */}

          {tournamentData.length > 0 && (
            <div className="pagination">
              <button
                disabled={tournamentPage === 1}
                onClick={() =>
                  loadTournamentData(selectedTournamentUser.userId, tournamentPage - 1,
                    sourceFilter,
                    fromDate,
                    toDate,
                    matchDurationFilter,
                    color,
                    result
                  )
                }
              >
                Prev
              </button>

              {getPaginationRange(tournamentPage, tournamentTotalPages).map(
                (page, index) =>
                  page === "..." ? (
                    <span key={`dots-${index}`} className="dots">...</span>
                  ) : (
                    <button
                      key={`page-${page}`}
                      className={Number(tournamentPage) === page ? "active" : ""}
                      onClick={() =>
                        loadTournamentData(selectedTournamentUser.userId, page, sourceFilter,
                          fromDate,
                          toDate,
                          matchDurationFilter,
                          color,
                          result
                        )
                      }
                    >
                      {page}
                    </button>
                  )
              )}


              <button
                disabled={tournamentPage === tournamentTotalPages}
                onClick={() =>
                  loadTournamentData(selectedTournamentUser.userId, tournamentPage + 1, sourceFilter,
                    fromDate,
                    toDate,
                    matchDurationFilter,
                    color,
                    result
                  )
                }
              >
                Next
              </button>
            </div>
          )}




        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setTournamentModalOpen(false)}
            variant="contained"
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={matchModalOpen}
        onClose={() => setMatchModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          Match Details
        </DialogTitle>

        <DialogContent>
          {selectedMatch && (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "12px",
              }}
            >
              <tbody>
                <tr>
                  <td><strong>Match ID</strong></td>
                  <td>{selectedMatch.matchId ? selectedMatch.matchId : "-"}</td>
                </tr>

                <tr>
                  <td><strong>Tournament ID</strong></td>
                  <td>{selectedMatch.tournamentId ? selectedMatch.tournamentId : "-"}</td>
                </tr>

                <tr>
                  <td><strong>Round No.</strong></td>
                  <td>{selectedMatch.roundNo ? selectedMatch.roundNo : "-"}</td>
                </tr>

                <tr>
                  <td><strong>Total Moves</strong></td>
                  <td>{selectedMatch?.noOfMoves ? selectedMatch?.noOfMoves : "-"}</td>
                </tr>

                <tr>
                  <td><strong>Winner</strong></td>
                  <td>{selectedMatch.result ? selectedMatch.result : "-"}</td>
                </tr>

                <tr>
                  <td><strong>Winner By</strong></td>
                  <td>{selectedMatch.decidedBy ? selectedMatch.decidedBy : "-"}</td>
                </tr>
              </tbody>
            </table>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setMatchModalOpen(false)}
            variant="contained"
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={sideOpen}
        onClose={() => setSideOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            height: "80vh",
            // overflow: "hidden"    
          }
        }}    >
        {/* <DialogTitle></DialogTitle> */}
        <h2>Game Analysis</h2>

        <DialogContent dividers>

          {/*  Dynamic Tabs */}
          <Tabs
            value={selectedTab}
            onChange={(e, newValue) => {
              setSelectedTab(newValue);

              const tabType = moveTypes[newValue];

              const movesOfTab =
                matchMovesData?.moves?.filter(
                  m => m.moveType === tabType
                ) || [];

              setSelectedMove(movesOfTab[0] || null);
            }}

            variant="scrollable"
            scrollButtons="auto"
            sx={{ marginBottom: 2 }}
          >
            {moveTypes.map((type, index) => (
              <Tab key={index} label={type} />
            ))}
          </Tabs>

          <Box
            sx={{
              display: "flex",
              gap: 3,
              height: "500px"
            }}
          >

            {/* LEFT SIDE - Move List */}
            <Box>
              <Box
                ref={listContainerRef}
                sx={{
                  width: "100%",
                  overflowY: "auto",
                  borderRight: "1px solid #eee",
                  height: "500px",
                  paddingRight: 2
                }}
              >
                {moveTypes[selectedTab] === "Full Game"
                  ? getGroupedFullGameMoves().map((m, i) => (
                    <Box
                      key={i}
                      sx={{
                        padding: 1.5,
                        borderBottom: "1px solid #f1f1f1",
                        display: "flex",
                        justifyContent: "space-between",
                        "&:hover": {
                          backgroundColor: "#f9f9f9"
                        }
                      }}
                    >
                      {/* Move Number */}
                      <Box sx={{ width: "10%", paddingRight: 2 }}>
                        {m.moveNumber}
                      </Box>

                      {/* White Move */}
                      <Box
                        ref={(el) => {
                          if (el && m.white)
                            moveRefs.current[`${m.white.moveNumber}-${m.white.move}`] = el;
                        }}
                        sx={{
                          width: "40%",
                          cursor: "pointer",
                          backgroundColor:
                            selectedMove?.moveNumber === m.white?.moveNumber &&
                              selectedMove?.move === m.white?.move
                              ? "#e3f2fd"
                              : "transparent",
                          borderRadius: 1,
                          padding: "4px 6px"
                        }}
                        onClick={() => setSelectedMove(m.white)}
                      >
                        {m.white?.san}
                      </Box>

                      {/* Black Move */}
                      <Box
                        ref={(el) => {
                          if (el && m.black)
                            moveRefs.current[`${m.black.moveNumber}-${m.black.move}`] = el;
                        }}
                        sx={{
                          width: "40%",
                          cursor: "pointer",
                          backgroundColor:
                            selectedMove?.moveNumber === m.black?.moveNumber &&
                              selectedMove?.move === m.black?.move
                              ? "#e3f2fd"
                              : "transparent",
                          borderRadius: 1,
                          padding: "4px 6px"
                        }}
                        onClick={() => setSelectedMove(m.black)}
                      >
                        {m.black?.san}
                      </Box>
                    </Box>
                  ))



                  : filteredMoves.map((pair, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #f1f1f1",
                        padding: 1.5,
                      }}
                    >

                      <Box sx={{ width: "10%", paddingRight: 2 }}>
                        {pair.white.moveNumber}
                      </Box>

                      {/* White Move */}
                      <Box
                        ref={(el) => {
                          if (el && pair.white)
                            moveRefs.current[`${pair.white.moveNumber}-${pair.white.move}`] = el;
                        }}
                        sx={{
                          width: "48%",
                          cursor: "pointer",
                          backgroundColor:
                            index === currentPairIndex &&
                              selectedMove?.move === pair.white?.move
                              ? "#f5f5f5"
                              : "transparent",
                          "&:hover": { backgroundColor: "#f9f9f9" }
                        }}
                        onClick={() => pair.white && setSelectedMove(pair.white)}
                      >
                        {pair.white?.san}
                      </Box>

                      {/* Black Move */}
                      <Box
                        ref={(el) => {
                          if (el && pair.black)
                            moveRefs.current[`${pair.black.moveNumber}-${pair.black.move}`] = el;
                        }}
                        sx={{
                          width: "48%",
                          cursor: "pointer",
                          backgroundColor:
                            selectedMove?.move === pair.black?.move ? "#f5f5f5" : "transparent",
                          "&:hover": { backgroundColor: "#f9f9f9" }
                        }}
                        onClick={() => pair.black && setSelectedMove(pair.black)}
                      >
                        {pair.black?.san}
                      </Box>
                    </Box>
                  ))}


              </Box>
              <Box sx={{
                paddingTop: 2
              }}>
                <h3>Total Moves: {moveTypes[selectedTab] === "Full Game" ? getGroupedFullGameMoves().length : filteredMoves?.length}</h3>
              </Box>
            </Box>


            {/* RIGHT SIDE - Chessboard */}
            <Box
              sx={{
                width: "65%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              {selectedMove && (
                <>


                  {/* Chessboard */}
                  <MatchMoves
                    pgn={matchMovesData?.pgn}
                    moveData={selectedMove}
                    seletedTab={moveTypes[selectedTab]}
                    color={matchMovesData?.moves[0]?.color}
                  />

                  {/* Navigation Buttons */}


                </>
              )}
            </Box>

            <Box>
              <div >
                <div>
                  <h4>
                    Actual Move :{" "}
                    <span style={{ color: "#d50000" }}>Red</span>
                  </h4>

                  <h4>
                    Best Move :{" "}
                    <span style={{ color: "green" }}>Green</span>
                  </h4>

                  <h4>
                    Best Response :{" "}
                    <span style={{ color: "orange" }}>Orange</span>
                  </h4>
                </div>
              </div>
              <div>
                {moveTypes[selectedTab] === "Full Game" ? (
                  <Box>
                    < Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 2,
                        marginTop: 45,
                        gap: 3
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={handlePrevFullGame}
                        disabled={currentIndexfullGame <= 0}
                      >
                        ⬅ Previous
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={handleNextFullGame}
                        disabled={currentIndexfullGame >= allMoves.length - 1}
                      >
                        Next ➡
                      </Button>

                    </Box>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {!(currentIndexfullGame >= allMoves.length - 1) && (
                        <Button
                          variant="outlined"
                          // color={isPlaying ? "error" : "success"}
                          onClick={isPlaying ? stopAutoPlay : startAutoPlay}
                        >
                          {isPlaying ? "Pause ⏸" : "Auto Play ▶"}
                        </Button>
                      )}
                    </div>
                  </Box>

                ) : (< Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 2,
                    marginTop: 50,
                    gap: 5
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={handlePrev}
                    disabled={currentPairIndex <= 0}
                  >
                    ⬅ Previous
                  </Button>


                  <Button
                    variant="outlined"
                    onClick={handleNext}
                    disabled={currentPairIndex === -1 || currentPairIndex >= filteredMoves.length - 1}
                  >
                    Next ➡
                  </Button>
                </Box>)}
              </div>
            </Box>

          </Box>
        </DialogContent>

      </Dialog>





    </div >




  );






};

export default TeamManage;
